// extracted by mini-css-extract-plugin
module.exports = {"container":"rating_container__X_YXd","title":"rating_title__tFE3q","stars":"rating_stars__K6Dug","active":"rating_active__NBUcP","hover":"rating_hover___EkKw"};